var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1972_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3233 0.25C14.327 0.250001 15.2635 7.2788 15.2635 7.2788L15.2802 14.5606H29.5908V16.7469H9.5961C9.5961 16.7469 0 15.5707 0 31.9248C-1.06957e-06 48.2789 8.37569 47.6989 8.37569 47.6989H13.3744V40.11C13.3744 40.11 13.1049 31.0575 21.6163 31.0575H35.8098C35.8098 31.0575 43.7843 31.1968 43.7843 22.7277V8.72431C43.7843 8.72431 44.995 0.25 29.3233 0.25ZM21.4324 5.14667C22.8562 5.14667 24.007 6.39043 24.007 7.92928C24.007 9.46813 22.8562 10.7119 21.4324 10.7119C20.0086 10.7119 18.8578 9.46813 18.8578 7.92928C18.8578 6.39043 20.0086 5.14667 21.4324 5.14667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7491 63.7635C44.7453 63.7635 43.8089 56.7347 43.8089 56.7347L43.7921 49.4529H29.4816V47.2666H49.4762C49.4762 47.2666 59.0723 48.4428 59.0723 32.0887C59.0723 15.7346 50.6966 16.3146 50.6966 16.3146H45.698V23.9035C45.698 23.9035 45.9674 32.956 37.456 32.956H23.2625C23.2625 32.956 15.288 32.8167 15.288 41.2858V55.2892C15.288 55.2892 14.0773 63.7635 29.7491 63.7635ZM37.6399 58.8668C36.2161 58.8668 35.0654 57.623 35.0654 56.0842C35.0654 54.5453 36.2161 53.3016 37.6399 53.3016C39.0637 53.3016 40.2145 54.5453 40.2145 56.0842C40.2145 57.623 39.0637 58.8668 37.6399 58.8668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1972_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.215,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.ed027a67c4fe033d228b57d808ce56b4.svg";
export { ForwardRef as ReactComponent };